// @flow

// Configure the id of the extra that should be toggled together with VBMR.
export const defaultVbmrExtraId = 175;

// Only check VBMR for these configuration sections.
export const vbmrCheckSections = ['accessory', 'color', 'extra contract', 'package'];
